import styled from 'styled-components';
import Image from '../../common/Image/Image';

/*** image container */

export const ImageBannerContainer = styled(Image)(
  props => `
  width: 100%;
  // height: 16rem;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  // object-fit: contain; // cover
  margin-top:${props.theme.spacing.small.s5};
  margin-bottom:${props.theme.spacing.small.s5};
`,
);

export const SliderArrowRight = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.white.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  `,
);

export const SliderArrowLeft = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.white.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -1rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  `,
);
